import styled from "styled-components";

const ParamsTitle = styled.p`
  margin-bottom: 40px;
  font-size: 34px;
  font-family: 'Gilroy-Bold';
  
  @media all and (max-width: 520px) {
    margin-bottom: 20px;
    font-size: 30px;
  }
`;

export default ParamsTitle;